export enum OfflineStrategy {
    NetworkFirst,
    NetworkOnly,
    CacheFirst,
    CacheOnly
}